import React from "react";
import "jspdf-autotable";
import { useParams } from "react-router-dom";
import {
  GetModuleAudit,
  GetModuleAuditFilters
} from "../../../services/ProgramService";
import { RenderAuditTrailResourceType } from "../../../utils/CommonGroupingItem";
import AuditTrailsTable from "../../common/AuditTrailsTable";

const AuditTrail = () => {
  const {id} = useParams()

  const columnsToShow = ["Action Type", "Resource Type", "Resource Name"]

  return (
    <AuditTrailsTable
      apiFunction={GetModuleAudit}
      apiParams={{action_id: id}}
      columnsToShow={columnsToShow}
      filterArrApi={GetModuleAuditFilters}
      actionId={id}
      exportFileName={"Module_AuditTrails"}
      // resourceNameRedirect={handleRedirect}
      isResourceNameShown={true}
      isShowingResourceTypeFilter
      renderResourceTypeFunction={RenderAuditTrailResourceType}
    />
  )
}
export default AuditTrail;
